<template>
	<div class="payment-method-wrapper">
		<div class="content">
			<div class="payment-list">
				<!-- Member Payment List -->
				<div
					class="item payment"
					v-for="(payment, index) in memberPayments"
					:key="index"
					@click="selectPayment(payment, index)"
				>
					<div>
						{{ payment.payment_name }} - {{ payment.data.nickname }} -
						{{ payment.data.card_number }}
					</div>
					<div v-if="payment.is_default === 1">
						<img
							class="checked"
							src="~@/assets/image/common/checked.png"
							alt="default payment"
						/>
					</div>
				</div>
				<!-- Member Payment List -->
				<!-- Empty Record -->
				<div class="empty-record" v-if="memberPayments.length === 0">
					<p>{{ i18n.t('payment.no_payment') }}</p>
				</div>
				<!-- Empty Record -->
				<!-- Edit Payment Button -->
				<div
					class="item edit-payment"
					key="edit-payment"
					@click="redirectToListCreditPage()"
				>
					<div>
						<span class="iconfont">&#xe6e1;</span>
						{{ i18n.t('payment.edit_credit') }}
					</div>
				</div>
				<!-- Edit Payment Button -->
			</div>
		</div>
		<div class="footer">
			<mt-button
				size="large"
				class="ds-button-large common-btn"
				@click="updatePayment()"
				>{{ i18n.t('general.confirm') }}</mt-button
			>
		</div>
	</div>
</template>

<script>
import { getPaymentList, defaultPayment } from '@/api/memberPayment'
import { Platform } from '@/const/payment'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'

export default {
	name: 'PaymentMethod',
	props: {
		platform: {
			type: String,
			default: Platform.H5
		},
		paySn: {
			type: String,
			require: false
		}
	},
	data: function () {
		return {
			i18n,
			memberPayments: [],
			supportPayments: [],
			beforeDefaultPaymentIndex: 0
		}
	},
	computed: {
		selectedPayment () {
			return this.memberPayments.find((payment) => payment.is_default === 1)
		}
	},
	methods: {
		selectPayment (payment, index) {
			defaultPayment(payment.id).then((res) => {
				this.memberPayments[this.beforeDefaultPaymentIndex].is_default = 0
				this.memberPayments[index].is_default = 1
				this.beforeDefaultPaymentIndex = index
			})
		},
		sortDefaultPaymentToFirst () {
			this.memberPayments = this.memberPayments.sort((a, b) => {
				if (a.is_default === 1) {
					return -1
				}
				return 1
			})
		},
		redirectToListCreditPage () {
			const route = router.history.current
			store.dispatch('closePaymentConfirmModal')
			router.push({ name: 'MemberCredits' })
		},
		updatePayment () {
			if (!this.selectedPayment) {
				return store.dispatch('closePaymentConfirmModal')
			}
			this.$emit('updatePayment', this.selectedPayment)
		}
	},
	created: function () {
		getPaymentList(this.platform).then((res) => {
			const results = res.result
			this.supportPayments = results.payments
			this.memberPayments = results.payment_list
			this.sortDefaultPaymentToFirst()
		})
	}
}
</script>

<style lang='scss' scoped>
$itemBackgroundColor: #ffda56;
$paymentItemTextColor: #5a5a5a;

.mint-button--default.is-plain {
	border: none;
}

.payment-method-wrapper {
	height: 72vh;
	display: flex;
	flex-direction: column;
	.content {
		flex: 1;
		margin-top: 1rem;
		overflow-y: auto;
	}
	.footer {
		margin-top: auto;
	}
	.payment-list {
		.item {
			font-size: 0.7rem;
			padding: 0.8rem;
			border-radius: 35px;
			background-color: $itemBackgroundColor;
			color: $paymentItemTextColor;
			margin-bottom: 0.6rem;
		}
		.payment {
			display: flex;
			justify-content: space-between;
			align-items: center;
			.checked {
				flex: 1;
				height: 1.5rem;
			}
		}
		.edit-payment {
			text-align: center;
		}
	}

	.empty-record {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		margin-bottom: 1rem;
		p {
			font-size: 0.8rem;
		}
	}
}
</style>
